import React from "react";
import { Radio, RadioProps, withStyles } from "@material-ui/core";

// ✅ Create styled radio
const StyledRadio = withStyles({
  root: {
    padding: 0, // 👈 removes default padding
    margin: 0, // 👈 removes margin if any
    color: "#6A60F5", // unchecked color
    "&$checked": {
      color: "#6A60F5",
    },
  },
  checked: {},
})(Radio);

const ZypleRadio: React.FC<RadioProps> = (props) => {
  return <StyledRadio {...props} />;
};

export default ZypleRadio;
